module.exports = __webpack_public_path__ + "static/self-help-tools-55cc57601bc169745d07ebfe21ee0f37.png";